import React, { useState } from 'react';
// import { useHistory } from 'react-router-dom';
import { makeStyles} from '@material-ui/core';
// import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import ModalStandart from './Modal';
// import SaveIcon from '@material-ui/icons/Save';



interface EstadoTernarioProps {
  info: {
    nombre: string;
    ps: string;
    cedula: string;
    legajo: string;
    fecha: string;
    horario: string;
    tipo: string;
    pscodigo: string;
   
  }
}



const useStyles = makeStyles((theme) => ({
  root:{
    padding: '20px',
    margin: theme.spacing(2)
  },
  text: {
    color: 'white',
  },
  colorModal: {
    color: 'black',
    margin: theme.spacing(3),
  },
  button: {
    backgroundColor: '#900533',
    width: '80%',
    margin: theme.spacing(3),
  },
  buttonGroup: {
    alignContent: 'space-between',
    width: '100%',
    marginTop: '15px',
  
  },
  ico: {
    color: 'white',
    fontSize: '30px',
    marginBottom: '10px',
    borderRadius: '50%',
    backgroundColor: '#900533',
    padding: '3px',
    cursor: 'pointer',
  },
  input: {
    margin: theme.spacing(1),
  },
}
));

const GestionTipoHora: React.FC<EstadoTernarioProps> = () => {
  const classes = useStyles();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [modalContent, setModalContent] = useState<JSX.Element | null>(null);
  const [textoModal, setTextoModal] = useState<string>('');
  // const history = useHistory();
 
  // const handleRedirect = (info: any) => {
  //   const dato = JSON.parse(JSON.stringify(info))
  //   history.push({
  //     pathname: '/gestionTipoHoraProcesada',
  //     key: dato,
  //   });
  // };
  
  const handleCloseModal = () => {
    setModalVisible(false);
    setModalContent(null);
    setTextoModal('');
  };

  const renderAccion = () => {
        return (<></>);

    }

  return (
    <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
      {renderAccion()}
      {modalVisible && modalContent && (
        <ModalStandart
          className={classes.colorModal}
          onClose={handleCloseModal}
          text={textoModal}
          body={() => modalContent}
        />
      )}
    </div>
  );
};

export default GestionTipoHora;